import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { ButtonLink, Heading, Stack, Text } from '@eneco/sparky';

import { RegistrationAccountContent } from '../registrationFlow.types';


export const RegisterSuccess: FC = () => {
  const content = useContent<RegistrationAccountContent>();
  return (
    <Stack gap="6">
      <Heading as="h1" size="XS">
        {content.RegisterSuccess_title}
      </Heading>
      <Text>{content.RegisterSuccess_introductionText}</Text>
      <ButtonLink href={content.link?.href}>{content.link?.text}</ButtonLink>
    </Stack>
  );
};
